import { AudioLines, VideoIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * ReplyPreview component displays the parent message that is being replied to.
 * Used inside message bubbles to show context for reply messages.
 */
export default function ReplyPreview({
  replyToText,
  replyToMessageType,
  replyToMediaUrl,
  direction,
}) {
  const isMediaReply =
    replyToMessageType === 'image' ||
    replyToMessageType === 'video' ||
    replyToMessageType === 'audio';

  return (
    <div
      className={cn(
        'mb-1 flex gap-2 rounded-md border-l-2 border-primary/50 px-2 py-1',
        replyToMessageType === 'video' || replyToMessageType === 'audio'
          ? 'items-center'
          : 'items-start',
        direction === 'sent' ? 'bg-background/50' : 'bg-background/20'
      )}
    >
      {/* Show thumbnail for media replies */}
      {isMediaReply && replyToMediaUrl && (
        <div className='flex-shrink-0'>
          {replyToMessageType === 'image' && (
            <img
              src={replyToMediaUrl}
              alt='Reply to image'
              className='h-10 w-10 rounded object-cover'
            />
          )}
          {replyToMessageType === 'video' && (
            <VideoIcon className='h-5 w-5 text-muted-foreground' />
          )}
          {replyToMessageType === 'audio' && (
            <AudioLines className='h-5 w-5 text-muted-foreground' />
          )}
        </div>
      )}

      {/* Reply text or media type indicator */}
      <div className='min-w-0 flex-1'>
        <p
          className={cn(
            'line-clamp-2 text-xs opacity-80',
            direction === 'sent' ? 'text-foreground' : 'text-primary-foreground'
          )}
        >
          {replyToText ||
            (isMediaReply
              ? `${replyToMessageType
                  .charAt(0)
                  .toUpperCase()}${replyToMessageType.slice(1)}`
              : 'Message')}
        </p>
      </div>
    </div>
  );
}
